import React from "react";
import useStyles from "./styles";
// import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import {
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  Button,
  Box,
} from "@material-ui/core";
import imgWaitingAproWhite from "../../assets/img/exclamation-mark-white.svg";
import imgIPTU from "../../assets/img/iptu.svg";
import imgTL from "../../assets/img/tff.svg";
import imgITIV from "../../assets/img/icone_itiv.png";
import imgDefault from "../../assets/img/geral.svg";
import { convertDate } from "../../helper/convertDate";
import { cga, imoveis } from "../../helper/formatersMask";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ModalCardDebit(props) {
  const classes = useStyles();
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState("sm");

  function handleClose() {
    props.setOpenModal(false);
  }

  function getTextTypeDAM(IndicadoresDAM) {
    let content = "";
    let date = convertDate(IndicadoresDAM.DataOperacao);
    if (IndicadoresDAM.TipoOperacao === "ONLINE") {
      content = `Você solicitou o pagamento online no dia ${date}`;
    } else if (IndicadoresDAM.TipoOperacao === "BOLETO") {
      content = `Você emitiu o DAM para pagamento no dia ${date}`;
    } else if (IndicadoresDAM.TipoOperacao === "CARTAOCRED") {
      content = `Você solicitou o pagamento com cartão de crédito no dia ${date}`;
    } else {
      content = "";
    }
    return content;
  }

  function renderIconeCards(type) {
    switch (type) {
      case "IMOVEL":
        return <img src={imgIPTU} alt="IPTU" style={{ width: "36px" }} />;
      case "ESTABELECIMENTO":
        return <img src={imgTL} alt="TL/TRSD" className={classes.imgIco} />;
      case "ITIV":
        return <img src={imgITIV} style={{ width: "23px" }} alt="ITIV" />;
      default:
        return (
          <img
            src={imgDefault}
            alt="Icone default"
            className={classes.imgIco}
          />
        );
    }
  }

  function rederNumInscricao(numInscricao, tipoDebito) {
    if (tipoDebito === "IMOVEL") return imoveis(numInscricao);
    return cga(numInscricao);
  }

  return (
    <Dialog
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={props.openModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent className={classes.dialogContent}>
        <div className={classes.modalTitle}>
          <div className={classes.modalIcon}>
            {renderIconeCards(props.propsParent.contentCard.Tributo.Icone)}

            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              {props.propsParent.contentCard.Tributo.Nome}
            </Typography>
          </div>
          <div className={classes.modalDescription}>
            <p className={classes.descriptionDebit}>
              Nº de inscrição:
              <span className={classes.descriptionDebitContent}>
                {rederNumInscricao(
                  props.propsParent.contentCard.Contribuinte
                    .NumInscricaoFormatado,
                  props.propsParent.contentCard.Tributo.Icone
                )}
              </span>
            </p>
            {props.propsParent.contentCard.Contribuinte.EnderecoFormatado !==
              null &&
              props.propsParent.contentCard.Contribuinte.EnderecoFormatado !==
                undefined && (
                <p className={classes.descriptionDebit}>
                  Endereço:
                  <span className={classes.descriptionDebitContent}>
                    {
                      props.propsParent.contentCard.Contribuinte
                        .EnderecoFormatado
                    }
                  </span>
                </p>
              )}

            {props.propsParent.contentCard.Situacao !== null && (
              <div style={{ paddingTop: "10px" }}>
                <span className={classes.descriptionSituation}>
                  {props.propsParent.contentCard.Situacao}
                </span>
              </div>
            )}
          </div>
        </div>
        <div
          style={{ marginLeft: "-24px", display: "flex", alignItems: "center" }}
        >
          {props.propsParent.contentCard.IndicadoresDAM !== null &&
            props.propsParent.contentCard.IndicadoresDAM !== undefined && (
              <div>
                <div className={classes.modalItem}>
                  <div className={classes.warningDiv}>
                    <img
                      style={{ padding: "8px 35px" }}
                      src={imgWaitingAproWhite}
                      className={classes.IndicatorIcon}
                      alt="Indicando que possui DAM"
                    />
                  </div>
                  <div className={classes.warningDivNew}></div>
                </div>
                <p className={classes.warningItem}>
                  {getTextTypeDAM(props.propsParent.contentCard.IndicadoresDAM)}
                </p>
              </div>
            )}
        </div>
        {(props.propsParent.contentCard.Solicitacao == null ||
          props.propsParent.contentCard.Solicitacao === undefined) && (
          <Box display="flex" flexDirection="column">
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Exercício</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                {props.propsParent.contentCard.AnoExercicio}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Cota</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                {props.propsParent.contentCard.Parcela}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Data Referência</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                {props.propsParent.contentCard.DataReferenciaConvertida}
              </p>
            </div>

            {props.propsParent.contentCard.IndicadoresDAM !== null &&
              props.propsParent.contentCard.IndicadoresDAM !== undefined &&
              props.propsParent.isFindDAMPage !== undefined && (
                <div className={classes.modalItem}>
                  <p className={classes.modalTitleItem}>N° DAM</p>
                  <hr className={classes.hrSize}></hr>
                  <p className={classes.modalContentItem}>
                    {props.propsParent.contentCard.IndicadoresDAM.NumeroDam}
                  </p>
                </div>
              )}

            {props.propsParent.contentCard.IndicadoresDAM !== null &&
              props.propsParent.contentCard.IndicadoresDAM !== undefined &&
              props.propsParent.isFindDAMPage === undefined && (
                <Link
                  to={{
                    pathname: "/consultar-dam",
                    aboutProps: {
                      DAMValue:
                        props.propsParent.contentCard.IndicadoresDAM.NumeroDam,
                    },
                  }}
                  className={classes.linkToHome}
                >
                  <div className={classes.modalItem}>
                    <p className={classes.modalTitleItem}>N° DAM</p>
                    <hr className={classes.hrSize}></hr>
                    <p className={classes.modalContentItem}>
                      {props.propsParent.contentCard.IndicadoresDAM.NumeroDam}
                    </p>
                  </div>
                </Link>
              )}

            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Vencimento</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                {props.propsParent.contentCard.DataVencimentoConvertida}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Valor Original</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                R$ {props.propsParent.contentCard.ValorOriginalVirgula}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Correção</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                R$ {props.propsParent.contentCard.ValorCorrecaoVirgula}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Multa de Mora</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                R$ {props.propsParent.contentCard.ValorMultaVirgula}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Juros</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                R$ {props.propsParent.contentCard.ValorJurosVirgula}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Multa de Infração</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                R$ {props.propsParent.contentCard.ValorMultaInfracaoVirgula}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Honorários</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                R$ {props.propsParent.contentCard.ValorHonorariosVirgula}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Desconto</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                R$ {props.propsParent.contentCard.ValorDescontoVirgula}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Valor a pagar</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                R$ {props.propsParent.contentCard.ValorPagarVirgula}
              </p>
            </div>
            <div className={classes.modalItem}>
              <p className={classes.modalTitleItem}>Pagar até</p>
              <hr className={classes.hrSize}></hr>
              <p className={classes.modalContentItem}>
                {props.propsParent.contentCard.DataVencimentoConvertida}
              </p>
            </div>
          </Box>
        )}

        {props.propsParent.contentCard.Solicitacao !== null && (
          <Box display="flex" flexDirection="column">
            <div className={`${classes.modalItem} ${classes.modalItemSpace}`}>
              <p>Opção de pagamento</p>
              <hr className={classes.hrSizeDebitAutomatic}></hr>
              <p>Cotas</p>
            </div>
            <div className={`${classes.modalItem} ${classes.modalItemSpace}`}>
              <p>Banco</p>
              <hr className={classes.hrSizeDebitAutomatic}></hr>
              <p>Banco do Nordeste do Brasil S/A</p>
            </div>
            <div className={`${classes.modalItem} ${classes.modalItemSpace}`}>
              <p>Agência (sem DV)</p>
              <hr className={classes.hrSizeDebitAutomatic}></hr>
              <p>0000</p>
            </div>
            <div className={`${classes.modalItem} ${classes.modalItemSpace}`}>
              <p>Conta Corrente</p>
              <hr className={classes.hrSizeDebitAutomatic}></hr>
              <p>000000</p>
            </div>
            <div className={`${classes.modalItem} ${classes.modalItemSpace}`}>
              <p>DV</p>
              <hr className={classes.hrSizeDebitAutomatic}></hr>
              <p>0</p>
            </div>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalCardDebit;
